import React from "react";
import "./StatsMarquee.css";

const STATS = [
  { figure: "10M+", label: "real charts read" },
  { figure: "10K+", label: "Vedic rules encoded" },
  { figure: "24x7", label: "instant answers" },
];

/* Full-bleed marquee. The track holds three copies of the set and slides by
   exactly one copy, so the loop point is invisible. aria-hidden on the copies
   so a screen reader hears the three figures once, not three times. */
const StatsMarquee: React.FC = () => (
  <section className="statsmq" aria-label="Aura AI in numbers">
    <div className="statsmq-track">
      {[0, 1, 2].map((copy) => (
        <div className="statsmq-set" key={copy} aria-hidden={copy > 0}>
          {STATS.map((stat) => (
            <div className="statsmq-item" key={stat.label}>
              <span className="statsmq-figure">{stat.figure}</span>
              <span className="statsmq-label">{stat.label}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default StatsMarquee;
